import React from 'react';

const CartNumberTracking = ({ totalItems, }) => {
    return (React.createElement("div", { className: "shoppingCartProductNumber", style: { display: 'none' } }, totalItems));
};

export { CartNumberTracking };
